import React, { useState } from 'react';

export default function ContactForm() {
    const [formData, setFormData] = useState({
        name: '',
        email: '',
        subject: '',
        message: ''
    });
    const [status, setStatus] = useState(null);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setStatus('sending');
        try {
            const res = await fetch('/api/system/contact', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(formData)
            });
            const data = await res.json();
            if (res.ok) {
                setStatus('success');
                setFormData({ name: '', email: '', subject: '', message: '' });
            } else {
                setStatus('error');
            }
        } catch (err) {
            setStatus('error');
        }
    };

    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    return (
        <div style={{ padding: '20px', background: '#111', borderRadius: '8px', border: '1px solid #333', maxWidth: '500px', margin: '20px auto', color: '#fff' }}>
            <h3 style={{ marginTop: 0, color: '#0ff' }}>Contactez-nous</h3>
            <form onSubmit={handleSubmit} style={{ display: 'flex', flexDirection: 'column', gap: '15px' }}>
                <input
                    name="name"
                    placeholder="Votre Nom"
                    value={formData.name}
                    onChange={handleChange}
                    required
                    style={inputStyle}
                />
                <input
                    name="email"
                    type="email"
                    placeholder="Votre Email"
                    value={formData.email}
                    onChange={handleChange}
                    required
                    style={inputStyle}
                />
                <input
                    name="subject"
                    placeholder="Sujet"
                    value={formData.subject}
                    onChange={handleChange}
                    required
                    style={inputStyle}
                />
                <textarea
                    name="message"
                    placeholder="Votre message..."
                    value={formData.message}
                    onChange={handleChange}
                    required
                    rows="4"
                    style={inputStyle}
                />
                <button type="submit" disabled={status === 'sending'} style={buttonStyle}>
                    {status === 'sending' ? 'Envoi...' : 'Envoyer'}
                </button>
                {status === 'success' && <p style={{ color: '#0f0', textAlign: 'center' }}>Message envoyé !</p>}
                {status === 'error' && <p style={{ color: '#f00', textAlign: 'center' }}>Erreur lors de l'envoi.</p>}
            </form>
        </div>
    );
}

const inputStyle = {
    padding: '10px',
    background: '#222',
    border: '1px solid #444',
    color: '#fff',
    borderRadius: '4px'
};

const buttonStyle = {
    padding: '12px',
    background: '#0ff',
    color: '#000',
    border: 'none',
    borderRadius: '4px',
    fontWeight: 'bold',
    cursor: 'pointer'
};
